function zeroPad(value) {
    let str = String(value);

    if (str.length > 1) {
        return str;
    }

    return '0' + str;
}

let FormatHelper = {

    /**
     * Formats the specified date (or date string) as a yyyy-MM-dd date.
     * 
     * @param {Date|String} date 
     * @return String
     */
    date: function (date) {
        let d = new Date(date),
            month = zeroPad(d.getMonth() + 1),
            day = zeroPad(d.getDate()),
            year = d.getFullYear();

        return [year, month, day].join('-');
    },

    /**
     * Formats the specified date (or date string) as a HH:mm:ss time.
     * 
     * @param {Date|String} date 
     * @return String
     */
    time: function (date) {
        let d = new Date(date),
            hours = zeroPad(d.getHours()),
            minutes = zeroPad(d.getMinutes()),
            seconds = zeroPad(d.getSeconds());

        return [hours, minutes, seconds].join(':');
    },

    /**
     * Formats the specified date (or date string) as a yyyy-MM-dd HH:mm:ss date/time.
     * 
     * @param {Date|String} date 
     * @return String
     */
    dateTime: function (date) {
        return this.date(date) + ' ' + this.time(date);
    },

    /**
     * Turns an ISO 3166-1 alpha-2 country code into the corresponding flag emoji, by
     * mapping the two letters to their regional indicator symbols.
     *
     * @param {String} countryCode A two letter country code, e.g. 'se'. Case doesn't matter.
     * @return {String} The flag, or an empty string if the code isn't a country code.
     */
    countryFlag: function (countryCode) {
        if (!countryCode || !/^[a-z]{2}$/i.test(countryCode)) {
            return '';
        }

        // 0x1F1E6 is the regional indicator symbol for 'A'
        let codePoints = countryCode
            .toUpperCase()
            .split('')
            .map(letter => 0x1f1e6 + letter.charCodeAt(0) - 'A'.charCodeAt(0));

        return String.fromCodePoint(...codePoints);
    }
}

export default FormatHelper;